import React from 'react';
const TicketsReportConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/apps/report/ticket',
			component: React.lazy(() => import('./index.js'))
		}
	]
};
export default TicketsReportConfig;
